import React from 'react';
import { MetaPixel } from '../components/MetaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { MidCTASection } from '../components/MidCTASection';
import { TransformationSection } from '../components/TransformationSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-garden-medium selection:text-white" data-id="element-221">
      <MetaPixel data-id="element-222" />
      <UrgencyBar data-id="element-223" />
      <main data-id="element-224">
        <HeroSection data-id="element-225" />
        <ProblemSection data-id="element-226" />
        <PainPointsSection data-id="element-227" />
        <SolutionSection data-id="element-228" />
        <IncludesSection data-id="element-229" />
        <MidCTASection data-id="element-230" />
        <TransformationSection data-id="element-231" />
        <BonusSection data-id="element-232" />
        <PricingSection data-id="element-233" />
        <GuaranteeSection data-id="element-234" />
        <TestimonialsSection data-id="element-235" />
        <FAQSection data-id="element-236" />
        <FinalCTASection data-id="element-237" />
      </main>
      <Footer data-id="element-238" />
      <PurchasePopup data-id="element-239" />
    </div>;
}